import NotificationCenterComponent from '@/features/notifications/components/NotificationCenter/Component'
import { Provider } from '@/features/notifications/components/NotificationCenter/contexts/Portal'
import { useFirebaseNotificationsListeners } from '@/features/notifications/components/NotificationCenter/hooks/useFirebaseNotificationsListeners'
import { useFirebaseReadNotifications } from '@/features/notifications/components/NotificationCenter/hooks/useFirebaseReadNotifications'
import { FC } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

interface NotificationCenterProps {
    opened: boolean
    toggle: () => void
    toggleButtonStyle?: StyleProp<ViewStyle>
}

interface StatefulNotificationCenter extends FC<NotificationCenterProps> {
    PaperPortal: typeof Provider
}

const NotificationCenter: StatefulNotificationCenter = ({ opened, toggle, toggleButtonStyle }) => {
    const notifications = useFirebaseNotificationsListeners()

    const readNotifications = useFirebaseReadNotifications()

    return (
        <NotificationCenterComponent
            opened={opened}
            notifications={notifications}
            readNotifications={readNotifications}
            toggle={toggle}
            toggleButtonStyle={toggleButtonStyle}
        />
    )
}

NotificationCenter.PaperPortal = Provider

export default NotificationCenter
